import { useContext } from "react";
import { AppContext } from "../App";
import ClientsLanding from "../views/ClientsLanding";

export default function Clients() {
  const appContext = useContext(AppContext);

  if (!appContext.navSubItem && !appContext.navExtraItem && !appContext.navMoreItem) {
    return <ClientsLanding />;
  }

  return null;
}

